import { Component, Inject } from '@angular/core';
import { AssetConfigurationService } from '../../services/asset-configuration.service';
import { finalize, takeUntil } from 'rxjs/operators';

import { Subject } from 'rxjs';

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-manage-configuration',
  templateUrl: './manage-configuration.component.html',
  styleUrls: ['./manage-configuration.component.scss'],
})
export class ManageConfigurationComponent {
  public saveForAllDutyTypes = new FormControl(false);
  public loader: boolean;
  private ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(
    private assetConfigService: AssetConfigurationService,
    public dialogRef: MatDialogRef<ManageConfigurationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { isBasic: boolean; currentDutyType: string }
  ) {}

  public resetToDefaultConfiguration() {
    this.loader = true;
    const body = {
      ...(this.saveForAllDutyTypes.value ? { saveForAllDutyTypes: true } : { dutyType: this.data.currentDutyType }),
    };

    this.assetConfigService
      .updateDefaultConfiguration(body)
      .pipe(
        takeUntil(this.ngUnsubscribe),
        finalize(() => (this.loader = false))
      )
      .subscribe((res) => {
        this.dialogRef.close({ ...res, saveForAllDutyTypes: this.saveForAllDutyTypes });
      });
  }

  public ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
